import React from "react"
import styled from "styled-components"
import { Descripition, Headline, StyledGradientTitle } from "../../../utils"
import { Button } from "../../atoms"
import { ArrowRightOutlined } from "@ant-design/icons"
import { AosWrapper } from "../../molecules/AosWrapper"
import { useRouter } from "next/router"

const Wrapper = styled.div<{ $isLP?: boolean }>`
  padding: 80px 0px;
  position: relative;
  background: ${(props) =>
    props.$isLP
      ? props.theme.quoteGradientBackground
      : props.theme.bgRadialDeepBlue2};

  /* Mobile: 600 */
  @media (max-width: 600px) {
    padding: 40px 20px;
  }

  /* Tablet: 601 - 1024 */
  @media (min-width: 601px) and (max-width: 1023px) {
    padding: 50px 60px;
  }
`

const StyledGradientTitleText = styled(StyledGradientTitle)<{
  $isLP?: boolean
}>`
  ${(props) =>
    props.$isLP
      ? `
    background: none;
    -webkit-background-clip: unset;
    -webkit-text-fill-color: #ffffff;
    color: #ffffff;
  `
      : ""}
  @media (max-width: 567px) {
    font-size: 1.375rem;
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;

  /* common style for mobile and tab */
  @media (max-width: 1023px) {
    margin-top: 20px;
    button {
      height: 38px;
    }
  }
  /* Mobile: 600 */
  @media (max-width: 600px) {
    justify-content: start;
  }
`

const ContactUsComponent = ({ isLP = false }) => {
  const router = useRouter()
  return (
    <Wrapper $isLP={isLP}>
      <AosWrapper>
        <Headline>
          {" Don't hesitate to reach out to us -  "}
          <StyledGradientTitleText $isLP={isLP}>
            {"we're\n here to help!"}
          </StyledGradientTitleText>
        </Headline>

        <Descripition>
          {
            "To create innovative and tech-friendly software solutions that meet the evolving needs of businesses and\n consumers by outstanding group of people to outstanding group of individuals"
          }
        </Descripition>
        <ButtonWrapper>
          <Button
            buttonType={"secondary"}
            iconAlignment={"right"}
            icon={<ArrowRightOutlined />}
            onClick={() => router.push("/contact-us")}
            style={
              isLP ? { background: "#ffffff", color: "#000000" } : undefined
            }
          >
            {"CONTACT US"}
          </Button>
        </ButtonWrapper>
      </AosWrapper>
    </Wrapper>
  )
}

export { ContactUsComponent }
